import { environment } from "../../environments/environment";
import { stateManager } from "./state-manager";

/** Fetch the signed-in user's organisations, served from the shared 5-minute cache. */
export async function getOrganisations(): Promise<any[]> {
    return await stateManager.getCachedOrgs(async () => {
        const accessToken = localStorage.getItem("AccessToken");
        if (!accessToken) return [];
        const orgRes = await fetch(environment.baseUrl + "api/Organisation/OrganisationGet", {
            headers: { 'Authorization': `Bearer ${accessToken}` }
        });
        if (orgRes.ok) {
            const orgListResponse = await orgRes.json();
            return orgListResponse.data || [];
        }
        return [];
    });
}

/**
 * Resolve an organisation's display name from its id, for report runs that only
 * recorded the id. Returns an empty string when it cannot be resolved — better a
 * blank header than confidently printing the wrong company on a financial report.
 */
export async function getOrganisationName(organisationId?: string | null): Promise<string> {
    if (!organisationId) return '';
    try {
        const orgs = await getOrganisations();
        return orgs.find((o: any) => o.organisationID === organisationId)?.organisationName || '';
    } catch {
        return '';
    }
}
